import { render, staticRenderFns } from "./IbuttonConfig.vue?vue&type=template&id=531bb409&scoped=true"
import script from "./IbuttonConfig.vue?vue&type=script&lang=js"
export * from "./IbuttonConfig.vue?vue&type=script&lang=js"
import style0 from "./IbuttonConfig.vue?vue&type=style&index=0&id=531bb409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bb409",
  null
  
)

export default component.exports